var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFutureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.4V1.6C1 1.44087 1.06321 1.28826 1.17574 1.17574C1.28826 1.06321 1.44087 1 1.6 1H13.252C13.4111 1.00014 13.5636 1.06345 13.676 1.176L16.824 4.324C16.88 4.3799 16.9243 4.44632 16.9545 4.51943C16.9847 4.59254 17.0002 4.6709 17 4.75V20.4C17 20.4788 16.9845 20.5568 16.9543 20.6296C16.9242 20.7024 16.88 20.7685 16.8243 20.8243C16.7685 20.88 16.7024 20.9242 16.6296 20.9543C16.5568 20.9845 16.4788 21 16.4 21H1.6C1.52121 21 1.44319 20.9845 1.37039 20.9543C1.29759 20.9242 1.23145 20.88 1.17574 20.8243C1.12002 20.7685 1.07583 20.7024 1.04567 20.6296C1.01552 20.5568 1 20.4788 1 20.4Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1V4.4C13 4.55913 13.0632 4.71174 13.1757 4.82426C13.2883 4.93679 13.4409 5 13.6 5H17",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.53846C11.1221 7.95885 10.0166 7.55608 9 7.53069M9 7.53069C7.79 7.50023 6.70833 8.00538 6.70833 9.38462C6.70833 11.9231 11.75 10.6538 11.75 13.1923C11.75 14.6401 10.408 15.262 9 15.2155M9 7.53069V6M6.25 14.0385C6.84033 14.7662 7.93942 15.1808 9 15.2155M9 15.2155V17",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureIcon);
export default __webpack_public_path__ + "static/media/future_icon.d2e14df36bd66b259d25f3b3e9d42fd3.svg";
export { ForwardRef as ReactComponent };